import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-caption" }
const _hoisted_3 = { class: "text-h6 text-right mb-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_alert = _resolveComponent("v-alert")
  const _component_router_link = _resolveComponent("router-link")
  const _component_v_col = _resolveComponent("v-col")
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_card = _resolveComponent("v-card")
  const _component_v_form = _resolveComponent("v-form")
  const _component_v_container = _resolveComponent("v-container")

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "fill-height",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "8",
            lg: "6"
          }, {
            default: _withCtx(() => [
              ($data.submitted)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "success",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" Thanks! We've received your order request and will email you to confirm and arrange payment. ", -1)
                    ]))]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "mb-4" }, "Your Cart", -1)),
                    (_ctx.items.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                          _cache[9] || (_cache[9] = _createTextVNode(" Your cart is empty. ", -1)),
                          _createVNode(_component_router_link, { to: "/merch" }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode("Browse merch", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[10] || (_cache[10] = _createTextVNode(". ", -1))
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                            return (_openBlock(), _createBlock(_component_v_card, {
                              key: `${item.productId}-${item.size}`,
                              class: "mb-3 pa-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  align: "center",
                                  "no-gutters": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, _toDisplayString(item.name), 1),
                                        _createElementVNode("div", _hoisted_2, "Size: " + _toDisplayString(item.size), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "auto",
                                      class: "mr-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          "model-value": item.qty,
                                          type: "number",
                                          min: "1",
                                          density: "compact",
                                          style: {"width":"80px"},
                                          "hide-details": "",
                                          "onUpdate:modelValue": (val) => $options.onQtyChange(item, val)
                                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "auto",
                                      class: "mr-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" £" + _toDisplayString((item.price * item.qty).toFixed(2)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "auto" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          icon: "mdi-close",
                                          variant: "text",
                                          onClick: $event => (_ctx.removeItem(item.productId, item.size))
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createElementVNode("p", _hoisted_3, "Total: £" + _toDisplayString(_ctx.subtotal.toFixed(2)), 1),
                          _createVNode(_component_v_form, { ref: "orderForm" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: $data.name,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.name) = $event)),
                                label: "Name",
                                rules: [$options.required]
                              }, null, 8, ["modelValue", "rules"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: $data.email,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.email) = $event)),
                                label: "Email",
                                rules: [$options.required, $options.emailRule]
                              }, null, 8, ["modelValue", "rules"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: $data.addressLine1,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.addressLine1) = $event)),
                                label: "Address line 1",
                                rules: [$options.required]
                              }, null, 8, ["modelValue", "rules"]),
                              _createVNode(_component_v_text_field, {
                                modelValue: $data.addressLine2,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.addressLine2) = $event)),
                                label: "Address line 2 (optional)"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: $data.city,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.city) = $event)),
                                        label: "City",
                                        rules: [$options.required]
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: $data.postcode,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.postcode) = $event)),
                                        label: "Postcode",
                                        rules: [$options.required]
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_text_field, {
                                modelValue: $data.country,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.country) = $event)),
                                label: "Country",
                                rules: [$options.required]
                              }, null, 8, ["modelValue", "rules"]),
                              ($data.submitError)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 0,
                                    type: "error",
                                    class: "mb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($data.submitError), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                loading: $data.submitting,
                                disabled: $data.submitting,
                                onClick: $options.submitOrder
                              }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode(" Request Purchase ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["loading", "disabled", "onClick"])
                            ]),
                            _: 1
                          }, 512)
                        ], 64))
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}